export class CaseDetailPage {
  init(): void {
    // 導入事例詳細ページ
  }
}
